/**
 * Service Worker Registration
 * Handles PWA updates and offline capabilities
 */

import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    // Show update notification
    const shouldUpdate = confirm(
      'New version available! Click OK to update and reload the app.'
    );

    if (shouldUpdate) {
      updateSW(true);
    }
  },

  onOfflineReady() {
    console.log('App is ready to work offline!');

    // Optional: Show a subtle notification that offline mode is available
    // You could show a toast notification here instead of console.log
  },

  onRegistered(registration) {
    console.log('Service Worker registered:', registration);
  },

  onRegisterError(error) {
    console.error('Service Worker registration error:', error);
  }
});

// Export for potential manual control
export { updateSW };
